import { Box, Button, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { captureError } from '@/core/errors'

export type DisableMembershipCardModalProps = {
  open: boolean
  onClose: () => void
  onDisable: () => Promise<void>
}

export const DisableMembershipCardModal: FC<DisableMembershipCardModalProps> =
  ({ open, onClose, onDisable }) => {
    const { t } = useTranslation('consoleDigitalMembershipCard')
    const [loading, setLoading] = useState(false)

    const handleDisable = async () => {
      setLoading(true)
      return onDisable()
        .then(() => {
          onClose()
        })
        .catch(e => {
          captureError(e, 'consoleDigitalMembershipCardDisable')
        })
        .finally(() => {
          setLoading(false)
        })
    }

    return (
      <InformationModal
        open={open}
        onClose={onClose}
        title={t('disableSettingsModalTitle')}
        innerSx={{
          width: 300,
        }}
        content={
          <>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: 13,
                fontWeight: 300,
              }}
            >
              {t('disableSettingsDescription')}
            </Typography>

            <Box sx={{ mt: 4 }}>
              <Button
                color="primary"
                size="large"
                fullWidth
                onClick={handleDisable}
                loading={loading}
                disabled={loading}
              >
                {t('changeSettings')}
              </Button>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button variant="text" onClick={onClose}>
                {t('cancel')}
              </Button>
            </Box>
          </>
        }
      />
    )
  }
